export enum ProjectButtonsEnum {
  TriggerCall = 'TriggerCall',
  Action = 'Action',
}
